import React from 'react';
import { useWorkflow } from '../context/WorkflowContext';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiTarget, FiRefreshCw, FiActivity, FiSettings, FiKey, FiBookOpen, FiFileText, FiLogOut, FiBookmark, FiUser, FiZap } = FiIcons;

const Header = ({ user, onSignOut, isPublic, onSignIn }) => {
  const { phase, resetWorkflow, setPhase, apiKey, openRouterKey } = useWorkflow();
  const connectedCount = [apiKey, openRouterKey].filter(Boolean).length;

  return (
    <header className="bg-sonar-card/80 backdrop-blur-md border-b border-sonar-border sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 h-20 flex items-center justify-between">
        <div className="flex items-center gap-3 cursor-pointer group" onClick={() => setPhase(0)}>
          <div className="w-10 h-10 rounded-xl flex items-center justify-center text-sonar-green font-bold border border-sonar-green/30 group-hover:border-sonar-green transition-all bg-sonar-green/5 shadow-[0_0_15px_rgba(46,204,113,0.1)]">
            <SafeIcon icon={FiTarget} className="text-2xl" />
          </div>
          <div className="flex flex-col">
            <span className="font-black text-xl tracking-tighter text-white leading-none">
              CREDIT<span className="text-sonar-green">SONAR</span>
            </span>
            <span className="text-[10px] font-mono text-slate-500 tracking-[0.2em] uppercase">Intelligence Engine</span>
          </div>
        </div>

        <div className="hidden md:flex items-center gap-6">
          <button onClick={() => setPhase(0)} className={`text-xs font-bold uppercase tracking-widest ${phase === 0 ? 'text-sonar-green' : 'text-slate-400 hover:text-white'}`}>Platform</button>
          {!isPublic && <button onClick={() => setPhase(8)} className={`text-xs font-bold uppercase tracking-widest flex items-center gap-1.5 ${phase === 8 ? 'text-sonar-green' : 'text-slate-400 hover:text-white'}`}><SafeIcon icon={FiBookmark} className="text-xs" /> Saved</button>}
          <button onClick={() => setPhase(6)} className={`text-xs font-bold uppercase tracking-widest flex items-center gap-1.5 ${phase === 6 ? 'text-sonar-green' : 'text-slate-400 hover:text-white'}`}><SafeIcon icon={FiBookOpen} className="text-xs" /> Methodology</button>
          <button onClick={() => setPhase(7)} className={`text-xs font-bold uppercase tracking-widest flex items-center gap-1.5 ${phase === 7 ? 'text-amber-400' : 'text-slate-400 hover:text-white'}`}><SafeIcon icon={FiFileText} className="text-xs" /> Legal</button>
        </div>

        <div className="flex items-center gap-3">
          {isPublic ? (
            <div className="flex items-center gap-4 ml-4">
              <button onClick={onSignIn} className="text-xs font-bold uppercase tracking-widest text-slate-400 hover:text-white transition-colors">Sign In</button>
              <button onClick={onSignIn} className="bg-sonar-green text-black px-6 py-2.5 rounded-xl font-black uppercase text-xs tracking-widest hover:bg-sonar-green-glow transition-all shadow-[0_0_15px_rgba(46,204,113,0.2)]">Get Started</button>
            </div>
          ) : (
            <>
              {user?.plan === 'pro' && (
                <div className="hidden lg:flex items-center gap-2 px-3 py-1.5 rounded-full border border-sonar-green/30 bg-sonar-green/10 text-sonar-green text-[10px] font-black uppercase tracking-widest">
                  <SafeIcon icon={FiZap} className="animate-pulse" /> Pro Access
                </div>
              )}
              <button onClick={() => setPhase(5)} className={`hidden sm:flex items-center gap-2 px-3 py-2 rounded-xl border text-xs font-bold uppercase tracking-widest transition-all ${connectedCount === 2 ? 'border-sonar-green/30 text-sonar-green bg-sonar-green/5' : 'border-sonar-border text-slate-500 hover:border-sonar-green hover:text-sonar-green'}`}>
                <SafeIcon icon={FiKey} className="text-xs" /> {connectedCount}/2 APIs
              </button>
              {user && (
                <div className="hidden sm:flex items-center gap-2 px-3 py-2 rounded-xl border border-sonar-border bg-sonar-bg">
                  <SafeIcon icon={FiUser} className="text-sonar-green text-xs" />
                  <span className="text-[10px] font-mono text-slate-400 max-w-[80px] truncate">{user.name || user.email}</span>
                </div>
              )}
              <button onClick={onSignOut} className="p-2.5 text-slate-500 hover:text-red-400 border border-sonar-border hover:border-red-400/30 rounded-xl transition-all"><SafeIcon icon={FiLogOut} className="text-sm" /></button>
            </>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;